class HandleUploadImageField {
    constructor() {
        // this.apiURL = 'http://localhost:3000';
        this.apiURL = 'https://herocovers-backend-446723.wl.r.appspot.com';
        this.input = document.getElementById('imageInput');
        this.form = document.getElementById('imageUploadForm');
        this.preview = document.getElementById('preview');
        this.resultContainer = document.querySelector('.upload-result');
    }

    uplodaImageEventListeners() {
        if (!this.input) return;
        this.input.addEventListener('change', (e) => this.handleFileSelect(e));
    }

    handleFileSelect(event) {
        let files = [];
        if (event.target.files) {
            files = Array.from(event.target.files);
        }
        if (files.length > 5) {
            alert('You can upload a maximum of 5 files.');
            this.input.value = ''; // Clear the input
            return;
        }

        this.preview.innerHTML = ''; // Clear previous previews
        files.slice(0, 5).forEach((file, index) => { // Limit to 5 files for display
            const reader = new FileReader();
            reader.onload = (e) => {
                const previewContainer = document.createElement('div');
                previewContainer.classList.add('preview-container');

                const img = document.createElement('img');
                img.src = e.target.result;
                img.classList.add('preview-image');

                const fileName = document.createElement('span');
                fileName.textContent = file.name;
                fileName.classList.add('file-name');

                const removeButton = document.createElement('button');
                removeButton.textContent = 'Remove';
                removeButton.classList.add('remove-button');
                removeButton.addEventListener('click', () => this.removePreview(index));

                previewContainer.appendChild(img);
                previewContainer.appendChild(fileName);
                previewContainer.appendChild(removeButton);
                this.preview.appendChild(previewContainer);
            };
            reader.readAsDataURL(file);
        });

        this.preview.classList.remove('hidden');
        // Clear previous results when new files are selected
        if (this.resultContainer) {
            this.resultContainer.innerHTML = '';
            this.resultContainer.classList.add('hidden');
        }
    }

    removePreview(index) {
        const files = Array.from(this.input.files);
        files.splice(index, 1);
        const dataTransfer = new DataTransfer();
        files.forEach(file => dataTransfer.items.add(file));
        this.input.files = dataTransfer.files;

        this.handleFileSelect({ target: { files: this.input.files } });
    }

    async uploadImage() {
        if (!this.input) {
            return;
        }
        const files = Array.from(this.input.files);
        if (files.length === 0) return;

        const formData = new FormData();
        files.forEach(file => formData.append('files[]', file));

        try {
            const response = await fetch(`${this.apiURL}/api/upload`, {
                method: 'POST',
                body: formData,
            });

            if (!response.ok) {
                throw new Error(`HTTP error! status: ${response.status}`);
            }

            const result = await response.json();
            const urls = await new Promise(resolve => {
                setTimeout(async () => {
                    const retrievedUrls = await this.retrieveFileImages(result.fileIds);
                    resolve(retrievedUrls);
                }, 2000); // Set timeout for 1 second
            });
            return urls;  // Return the URLs

        } catch (error) {
            console.error('Upload error:', error);
            this.displayError(error.message || 'Failed to upload files. Please try again.');
            return [];  // Return empty array on error
        }
    }

    async retrieveFileImages(fileImageIDs) {
        return fetch(`${this.apiURL}/api/files`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({
                fileImageIDs: fileImageIDs
            })
        }).then(response => {
            if (!response.ok) {
                throw new Error(`HTTP error! status: ${response.status}`);
            }
            return response.json();
        }).then(results => {
            return results;
        }).catch(error => {
            console.error('File Image ID error:', error);
            this.displayError(error.message || 'Failed to get file image IDs. Please try again.');
        })
    }

    displayError(message) {
        if (!this.resultContainer) {
            this.resultContainer = document.createElement('div');
            this.resultContainer.className = 'upload-result';
            this.form.appendChild(this.resultContainer);
        }

        this.resultContainer.innerHTML = `
            <div class="upload-error">
                <span class="error-icon">⚠</span>
                <p>${message}</p>
            </div>
        `;

        this.resultContainer.classList.remove('hidden');
    }
}

class FormAddonSelector {
    constructor() {
        this.formSelectorLayout = document.querySelector('.form-selector-layout');
        this.formSelectorWrapper = document.querySelector('.form-selector-wrapper');
        this.sizeSelectorWrapper = document.querySelector('.size-selector-wrapper');
        this.sizeSelectorResult = document.querySelector('.size-selector-result');

        if (!this.formSelectorLayout) {
            return;
        }

        this.materialOptionDivs = document.querySelectorAll(
            '.material-addons-selector .material-addon__option-item'
        );

        this.setsOptionDivs = document.querySelectorAll(
            '.select-set-addon .select-sets-addon__option-item'
        );

        this.vehicleKind = this.formSelectorLayout
            .getAttribute('data-vehicle-kind')
            ?.trim()
            .toLowerCase();

        this.automotiveArray = [
            'car',
            'suv',
            'truck',
            'hyper car',
            'monster truck'
        ];

        this.motorcycleArray = [
            'small',
            'medium',
            'large',
            'xl',
            'xxl'
        ];

        this.boatArray = [
            'jetski/dingy',
            'class a',
            'class b',
            'class 1',
            'class 2'
        ];

        this.automotiveSizePrice = {
            'car': {
                price: 0,
                variantId: ''
            },
            'suv': {
                price: 100_00,
                variantId: '44783797993643'
            },
            'truck': {
                price: 150_00,
                variantId: '44783798616235'
            },
            'hyper car': {
                price: 255_00,
                variantId: '44857589760171'
            },
            'monster truck': {
                price: 255_00,
                variantId: '44857581240491'
            }
        };

        this.motorcycleSizePrice = {
            'small': {
                price: 295_00,
                variantId: '44857996148907'
            },
            'medium': {
                price: 335_00,
                variantId: '44857997263019'
            },
            'large': {
                price: 385_00,
                variantId: '44857998377131'
            },
            'xl': {
                price: 425_00,
                variantId: '44857999032491'
            },
            'xxl': {
                price: 495_00,
                variantId: '44857999589547'
            }
        };

        this.boatSizePrice = {
            'jetski/dingy': {
                price: 295_00,
                variantId: '44293262147755'
            },
            'class a': {
                price: 1495_00,
                variantId: '44293709856939'
            },
            'class b': {
                price: 2495_00,
                variantId: '44293528846507'
            },
            'class 1': {
                price: 3495_00,
                variantId: '44293434245291'
            },
            'class 2': {
                price: 0,
                variantId: ''
            }
        };

        this.initSelectorCarForm();
    }


    async initSelectorCarForm() {

        if (!this.formSelectorWrapper || !this.formSelectorLayout) {
            return;
        }


        const fetchData = async (url) => {

            const response = await fetch(url);

            if (!response.ok) {
                throw new Error(
                    `Failed to load vehicle data. Status: ${response.status}`
                );
            }

            return await response.text();
        };


        try {

            const dataUrl = this.formSelectorLayout.getAttribute(
                'data-vehicle-list'
            );


            if (!dataUrl) {
                console.error('Vehicle data URL is missing.');
                return;
            }


            const data = await fetchData(dataUrl);


            const sizeFilterSettings = (
                this.formSelectorLayout.getAttribute(
                    'data-size-filter-settings'
                ) || 'all'
            )
                .trim()
                .toLowerCase();


            /*
             * ============================================
             * PARSE CSV
             * ============================================
             */

            const rows = data
                .split('\n')
                .map(row => row.replace('\r', '').split(','))
                .filter(row => row.some(cell => cell.trim() !== ''));


            if (rows.length < 2) {
                console.error('Vehicle CSV does not contain data.');
                return;
            }


            const headers = rows[0]
                .map(header => header.trim().toLowerCase());


            const yearIndex = headers.indexOf('year');
            const makeIndex = headers.indexOf('make');
            const modelIndex = headers.indexOf('model');
            const sizeIndex = headers.indexOf('size');


            if (
                yearIndex === -1 &&
                this.vehicleKind !== 'bike'
            ) {
                console.error(
                    'Year column was not found in vehicle CSV.'
                );
            }


            if (makeIndex === -1) {
                console.error(
                    'Make column was not found in vehicle CSV.'
                );
            }


            if (
                modelIndex === -1 &&
                this.vehicleKind !== 'bike'
            ) {
                console.error(
                    'Model column was not found in vehicle CSV.'
                );
            }


            if (
                sizeIndex === -1 &&
                this.vehicleKind !== 'bike'
            ) {
                console.error(
                    'Size column was not found in vehicle CSV.'
                );
            }


            /*
             * ============================================
             * FILTER VEHICLE DATA BY SIZE SETTINGS
             * ============================================
             */

            let filteredData = [];


            if (this.vehicleKind === 'automotive') {

                filteredData = rows
                    .slice(1)
                    .filter(row => {

                        const rowSize = (
                            row[sizeIndex] || ''
                        )
                            .trim()
                            .toLowerCase();


                        if (sizeFilterSettings === 'all') {
                            return this.automotiveArray.includes(
                                rowSize
                            );
                        }


                        return rowSize === sizeFilterSettings;
                    });
            }


            if (this.vehicleKind === 'motorcycle') {

                filteredData = rows
                    .slice(1)
                    .filter(row => {

                        const rowSize = (
                            row[sizeIndex] || ''
                        )
                            .trim()
                            .toLowerCase();


                        if (sizeFilterSettings === 'all') {
                            return this.motorcycleArray.includes(
                                rowSize
                            );
                        }


                        return rowSize === sizeFilterSettings;
                    });
            }


            if (this.vehicleKind === 'boat') {

                filteredData = rows
                    .slice(1)
                    .filter(row => {

                        const rowSize = (
                            row[sizeIndex] || ''
                        )
                            .trim()
                            .toLowerCase();


                        if (sizeFilterSettings === 'all') {
                            return this.boatArray.includes(
                                rowSize
                            );
                        }


                        return rowSize === sizeFilterSettings;
                    });
            }


            if (this.vehicleKind === 'bike') {

                filteredData = rows
                    .slice(1)
                    .filter(row => {

                        return row[makeIndex]?.trim();
                    });
            }


            /*
             * ============================================
             * NORMALIZE VEHICLE DATA
             * ============================================
             */

            const vehicles = filteredData.map(row => {

                return row.map(value => {

                    return (value || '').trim();
                });
            });


            /*
             * ============================================
             * GET YEARS FROM CSV
             *
             * IMPORTANT:
             * Do NOT use a hardcoded year range.
             *
             * This automatically includes:
             * - 2027
             * - 2026
             * - older years
             * - 1886
             *
             * as long as they exist in the CSV.
             * ============================================
             */

            const years = this.vehicleKind !== 'bike'
                ? [
                    ...new Set(
                        vehicles
                            .map(vehicle => vehicle[yearIndex])
                            .filter(Boolean)
                    )
                ]
                    .sort((a, b) => {

                        return Number(b) - Number(a);
                    })
                : [];


            console.log(
                'Available compatible years:',
                years
            );


            /*
             * ============================================
             * SIZE DISPLAY SPANS
             * ============================================
             */

            const sizeOptionSpans =
                this.sizeSelectorResult
                    ? Array.from(
                        this.sizeSelectorResult.querySelectorAll(
                            'span.size-display'
                        )
                    )
                    : [];


            /*
             * ============================================
             * CREATE SELECTS
             * ============================================
             */

            const yearSelect =
                this.vehicleKind !== 'bike'
                    ? this.createSizeSelect(
                        'year',
                        'Year',
                        years,
                        false
                    )
                    : null;


            const makeSelect =
                this.vehicleKind !== 'bike'
                    ? this.createSizeSelect(
                        'make',
                        'Make',
                        [],
                        true
                    )
                    : this.createSizeSelect(
                        'make',
                        'Make',
                        [
                            ...new Set(
                                vehicles
                                    .map(vehicle => {
                                        return vehicle[makeIndex];
                                    })
                                    .filter(Boolean)
                            )
                        ].sort(),
                        false
                    );


            const modelSelect =
                this.vehicleKind !== 'bike'
                    ? this.createSizeSelect(
                        'model',
                        'Model',
                        [],
                        true
                    )
                    : null;


            const trimInput = document.createElement('input');

            trimInput.type = 'text';
            trimInput.placeholder = 'Trim (Optional)';
            trimInput.classList.add(
                'trim-optional-input'
            );


            /*
             * ============================================
             * YEAR CHANGE
             *
             * Only show makes compatible with
             * the selected year.
             * ============================================
             */

            if (yearSelect) {

                yearSelect.addEventListener(
                    'change',
                    () => {

                        sizeOptionSpans.forEach(span => {

                            span.classList.add('hidden');
                        });


                        const selectedYear =
                            yearSelect.value;


                        /*
                         * Reset stored selections
                         */

                        this.formSelectorLayout.removeAttribute(
                            'data-selected-size'
                        );

                        this.formSelectorLayout.removeAttribute(
                            'data-selected-year'
                        );

                        this.formSelectorLayout.removeAttribute(
                            'data-selected-make'
                        );

                        this.formSelectorLayout.removeAttribute(
                            'data-selected-model'
                        );


                        /*
                         * No year selected
                         */

                        if (!selectedYear) {

                            this.updateSizeSelect(
                                makeSelect,
                                'Make',
                                [],
                                true
                            );


                            this.updateSizeSelect(
                                modelSelect,
                                'Model',
                                [],
                                true
                            );


                            return;
                        }


                        /*
                         * Get compatible makes
                         */

                        const filteredMakes = [

                            ...new Set(

                                vehicles
                                    .filter(vehicle => {

                                        return (
                                            vehicle[yearIndex] ===
                                            selectedYear
                                        );
                                    })
                                    .map(vehicle => {

                                        return vehicle[makeIndex];
                                    })
                                    .filter(Boolean)
                            )

                        ].sort();


                        this.updateSizeSelect(
                            makeSelect,
                            'Make',
                            filteredMakes,
                            false
                        );


                        /*
                         * Reset model
                         */

                        this.updateSizeSelect(
                            modelSelect,
                            'Model',
                            [],
                            true
                        );


                        /*
                         * Save selected year
                         */

                        this.formSelectorLayout.setAttribute(
                            'data-selected-year',
                            selectedYear
                        );
                    }
                );
            }


            /*
             * ============================================
             * MAKE CHANGE
             *
             * Only show models compatible with:
             *
             * Selected Year
             * +
             * Selected Make
             * ============================================
             */

            if (makeSelect) {

                makeSelect.addEventListener(
                    'change',
                    () => {

                        sizeOptionSpans.forEach(span => {

                            span.classList.add('hidden');
                        });


                        const selectedMake =
                            makeSelect.value;


                        /*
                         * BIKE
                         */

                        if (this.vehicleKind === 'bike') {

                            this.formSelectorLayout.setAttribute(
                                'data-selected-make',
                                selectedMake
                            );

                            return;
                        }


                        /*
                         * OTHER VEHICLES
                         */

                        const selectedYear =
                            yearSelect?.value;


                        this.formSelectorLayout.removeAttribute(
                            'data-selected-size'
                        );

                        this.formSelectorLayout.removeAttribute(
                            'data-selected-model'
                        );


                        if (
                            !selectedYear ||
                            !selectedMake
                        ) {

                            this.updateSizeSelect(
                                modelSelect,
                                'Model',
                                [],
                                true
                            );


                            return;
                        }


                        /*
                         * Get compatible models
                         */

                        const filteredModels = [

                            ...new Set(

                                vehicles
                                    .filter(vehicle => {

                                        return (

                                            vehicle[yearIndex] ===
                                            selectedYear

                                            &&

                                            vehicle[makeIndex] ===
                                            selectedMake
                                        );
                                    })

                                    .map(vehicle => {

                                        return vehicle[modelIndex];
                                    })

                                    .filter(Boolean)
                            )

                        ].sort();


                        this.updateSizeSelect(
                            modelSelect,
                            'Model',
                            filteredModels,
                            false
                        );


                        /*
                         * Save selected make
                         */

                        this.formSelectorLayout.setAttribute(
                            'data-selected-make',
                            selectedMake
                        );
                    }
                );
            }


            /*
             * ============================================
             * MODEL CHANGE
             *
             * Find the exact compatible vehicle:
             *
             * Year
             * +
             * Make
             * +
             * Model
             *
             * Then determine its size.
             * ============================================
             */

            if (modelSelect) {

                modelSelect.addEventListener(
                    'change',
                    () => {

                        const selectedYear =
                            yearSelect.value;

                        const selectedMake =
                            makeSelect.value;

                        const selectedModel =
                            modelSelect.value;


                        /*
                         * Clear previous size
                         */

                        sizeOptionSpans.forEach(span => {

                            span.classList.add('hidden');
                        });


                        this.formSelectorLayout.removeAttribute(
                            'data-selected-size'
                        );


                        if (
                            !selectedYear ||
                            !selectedMake ||
                            !selectedModel
                        ) {

                            return;
                        }


                        /*
                         * Find EXACT matching vehicle
                         */

                        const matchedVehicle =
                            vehicles.find(vehicle => {

                                return (

                                    vehicle[yearIndex] ===
                                    selectedYear

                                    &&

                                    vehicle[makeIndex] ===
                                    selectedMake

                                    &&

                                    vehicle[modelIndex] ===
                                    selectedModel
                                );
                            });


                        if (!matchedVehicle) {

                            console.warn(
                                'No compatible vehicle found for:',
                                {
                                    year: selectedYear,
                                    make: selectedMake,
                                    model: selectedModel
                                }
                            );


                            return;
                        }


                        /*
                         * Get vehicle size
                         */

                        const size = (
                            matchedVehicle[sizeIndex] || ''
                        )
                            .trim()
                            .toLowerCase();


                        /*
                         * Show matching size
                         */

                        const matchedSpan =
                            sizeOptionSpans.find(span => {

                                return (
                                    span.id
                                        .trim()
                                        .toLowerCase()
                                    ===
                                    size
                                );
                            });


                        sizeOptionSpans.forEach(span => {

                            span.classList.add('hidden');
                        });


                        if (matchedSpan) {

                            matchedSpan.classList.remove(
                                'hidden'
                            );
                        }


                        /*
                         * Save selections
                         */

                        this.formSelectorLayout.setAttribute(
                            'data-selected-size',
                            size
                        );


                        this.formSelectorLayout.setAttribute(
                            'data-selected-year',
                            selectedYear
                        );


                        this.formSelectorLayout.setAttribute(
                            'data-selected-make',
                            selectedMake
                        );


                        this.formSelectorLayout.setAttribute(
                            'data-selected-model',
                            selectedModel
                        );


                        /*
                         * Update product price
                         */

                        this.updatePrice();
                    }
                );
            }


            /*
             * ============================================
             * APPEND FORM ELEMENTS
             * ============================================
             */

            if (this.sizeSelectorWrapper) {

                if (yearSelect) {

                    this.sizeSelectorWrapper.appendChild(
                        yearSelect
                    );
                }


                if (makeSelect) {

                    this.sizeSelectorWrapper.appendChild(
                        makeSelect
                    );
                }


                if (modelSelect) {

                    this.sizeSelectorWrapper.appendChild(
                        modelSelect
                    );
                }


                /*
                 * Trim field
                 */

                if (
                    this.vehicleKind === 'automotive'
                    ||
                    this.vehicleKind === 'motorcycle'
                ) {

                    this.sizeSelectorWrapper.appendChild(
                        trimInput
                    );
                }


                /*
                 * ========================================
                 * OTHER VEHICLE
                 * ========================================
                 */

                const otherCarWrapper =

                    document.querySelector(
                        '.other-car-wrapper'
                    )

                    ||

                    document.querySelector(
                        '.other-car-manual-input-wrapper'
                    );


                if (otherCarWrapper) {

                    const otherCarCheckbox =
                        otherCarWrapper.querySelector(
                            '.other-car-checkbox input'
                        );


                    const otherCarInput =
                        otherCarWrapper.querySelector(
                            '.other-car-input input'
                        );


                    if (
                        otherCarCheckbox &&
                        otherCarInput
                    ) {

                        otherCarCheckbox.addEventListener(
                            'change',
                            () => {

                                if (
                                    otherCarCheckbox.checked
                                ) {

                                    sizeOptionSpans.forEach(
                                        span => {

                                            span.classList.add(
                                                'hidden'
                                            );
                                        }
                                    );


                                    otherCarInput.classList.remove(
                                        'hidden'
                                    );


                                    otherCarInput.disabled =
                                        false;


                                    this.sizeSelectorWrapper
                                        .querySelectorAll(
                                            'select'
                                        )
                                        .forEach(select => {

                                            select.selectedIndex = 0;

                                            select.disabled = true;

                                            select.value = '';
                                        });


                                    if (trimInput) {

                                        trimInput.value = '';

                                        trimInput.disabled = true;
                                    }


                                    /*
                                     * Clear compatibility selection
                                     */

                                    this.formSelectorLayout.removeAttribute(
                                        'data-selected-size'
                                    );

                                    this.formSelectorLayout.removeAttribute(
                                        'data-selected-year'
                                    );

                                    this.formSelectorLayout.removeAttribute(
                                        'data-selected-make'
                                    );

                                    this.formSelectorLayout.removeAttribute(
                                        'data-selected-model'
                                    );

                                } else {

                                    otherCarInput.classList.add(
                                        'hidden'
                                    );


                                    otherCarInput.disabled =
                                        true;


                                    if (yearSelect) {

                                        yearSelect.disabled =
                                            false;
                                    }


                                    if (trimInput) {

                                        trimInput.disabled =
                                            false;
                                    }
                                }
                            }
                        );
                    }
                }
            }


            /*
             * ============================================
             * MATERIAL SELECTOR
             * ============================================
             */

            this.materialOptionDivs.forEach(div => {

                const radioInput =
                    div.querySelector(
                        'input[type="radio"]'
                    );


                if (!radioInput) {
                    return;
                }


                radioInput.addEventListener(
                    'change',
                    () => {

                        if (radioInput.checked) {

                            const variantPrice =
                                radioInput.getAttribute(
                                    'data-variant-price'
                                );


                            this.formSelectorLayout.setAttribute(
                                'data-selected-material-price',
                                variantPrice || '0'
                            );


                            this.formSelectorLayout.setAttribute(
                                'data-selected-material-id',
                                radioInput.value
                            );


                            this.formSelectorLayout.setAttribute(
                                'data-selected-material-name',
                                radioInput.getAttribute(
                                    'data-material-name'
                                ) || ''
                            );


                            this.updatePrice();
                        }
                    }
                );
            });


            /*
             * ============================================
             * SET SELECTOR
             * ============================================
             */

            this.setsOptionDivs.forEach(div => {

                const radioInput =
                    div.querySelector(
                        'input[type="radio"]'
                    );


                if (!radioInput) {
                    return;
                }


                radioInput.addEventListener(
                    'change',
                    () => {

                        if (radioInput.checked) {

                            const variantPrice =
                                radioInput.getAttribute(
                                    'data-variant-price'
                                );


                            this.formSelectorLayout.setAttribute(
                                'data-selected-sets-price',
                                variantPrice || '0'
                            );


                            this.formSelectorLayout.setAttribute(
                                'data-selected-sets-id',
                                radioInput.value
                            );


                            this.formSelectorLayout.setAttribute(
                                'data-selected-sets-name',
                                radioInput.getAttribute(
                                    'data-material-name'
                                ) || ''
                            );


                            this.updatePrice();
                        }
                    }
                );
            });

        } catch (error) {

            console.error(
                'Error initializing vehicle selector:',
                error
            );
        }
    }


    /*
     * ================================================
     * UPDATE PRICE
     * ================================================
     */

    updatePrice() {

        const selectedSize =
            this.formSelectorLayout.getAttribute(
                'data-selected-size'
            ) || 'car';


        let sizePrice;


        if (this.vehicleKind === 'automotive') {

            sizePrice =
                this.automotiveSizePrice;

        } else if (
            this.vehicleKind === 'motorcycle'
        ) {

            sizePrice =
                this.motorcycleSizePrice;

        } else if (
            this.vehicleKind === 'boat'
        ) {

            sizePrice =
                this.boatSizePrice;

        } else {

            return;
        }


        if (
            Object.prototype.hasOwnProperty.call(
                sizePrice,
                selectedSize
            )
        ) {

            if (this.sizeSelectorWrapper) {

                this.sizeSelectorWrapper.setAttribute(
                    'data-selected-size-id',
                    sizePrice[selectedSize].variantId
                );
            }

        } else {

            console.log(
                'Error: Size not found in sizePrice object'
            );

            return;
        }


        const selectedMaterialPrice =
            parseFloat(
                this.formSelectorLayout.getAttribute(
                    'data-selected-material-price'
                )
            ) || 0;


        const selectedSizePrice =
            sizePrice[selectedSize].price || 0;


        const originalPrice =
            parseFloat(
                this.formSelectorLayout.getAttribute(
                    'data-product-price'
                )
            ) || 0;


        const totalPrice =

            originalPrice

            +

            selectedSizePrice

            +

            selectedMaterialPrice;


        const totalPriceString =
            (totalPrice / 100).toFixed(2);


        const totalPriceStringWithCurrency =
            `$${totalPriceString} USD`;


        const originalPriceSpan =
            document.querySelector(
                '.price-regular-full-price'
            );


        const customPriceRegularFullPrice =
            document.querySelector(
                '.custom-price-regular-full-price'
            );


        if (
            originalPriceSpan
            &&
            customPriceRegularFullPrice
        ) {

            originalPriceSpan.style.display =
                'none';


            customPriceRegularFullPrice.style.display =
                'block';


            customPriceRegularFullPrice.textContent =
                totalPriceStringWithCurrency;
        }
    }


    /*
     * ================================================
     * CREATE SELECT
     * ================================================
     */

    createSizeSelect(
        id,
        label,
        options,
        isDisabled
    ) {

        const select =
            document.createElement('select');


        select.id = id;


        select.disabled =
            isDisabled;


        this.updateSizeSelect(
            select,
            label,
            options,
            isDisabled
        );


        return select;
    }


    /*
     * ================================================
     * UPDATE SELECT OPTIONS
     * ================================================
     */

    updateSizeSelect(
        select,
        label,
        options,
        isDisabled
    ) {

        if (!select) {
            return;
        }


        select.innerHTML = '';


        const defaultOption =
            document.createElement('option');


        defaultOption.value = '';


        defaultOption.textContent =
            `Select ${label}`;


        select.appendChild(
            defaultOption
        );


        select.disabled =
            isDisabled;


        options.forEach(option => {

            const optionElement =
                document.createElement('option');


            optionElement.value =
                option;


            optionElement.textContent =
                option;


            select.appendChild(
                optionElement
            );
        });
    }
}

class AddToCartCustom {
    constructor() {
        this.originalProductFormButtons = document.querySelector('.product-form__buttons');
        this.originalProductFormEl = document.querySelector('product-form') || document.querySelector('.product-form');
        const productScript = document.getElementById(`ProductJSON-${this.getProductId()}`);
        this.productData = productScript ? JSON.parse(productScript.textContent) : null;
        this.formProduct = document.querySelector(`#product-form-${this.productData?.section_id}`);
        this.HandleUploadImageField = new HandleUploadImageField();
        this.formSelectorLayout = document.querySelector('.form-selector-layout');
        this.vehicleKind = this.formSelectorLayout?.getAttribute('data-vehicle-kind');
        this.formSelectorWrapper = document.querySelector('.form-selector-wrapper');

        if (this.originalProductFormButtons) {
            Array.from(this.originalProductFormButtons.children).forEach(child => {
                child.style.display = 'none';
            });
            this.initNewAddToCartButton();
        }
    }

    getProductId() {
        const productInfo = document.querySelector('product-info');
        return productInfo?.dataset?.productId;
    }

    initNewAddToCartButton() {
        const newAddToCartButton = document.createElement('button');
        newAddToCartButton.classList.add('custom-btn', 'form-addons-addToCart');

        const spinner = document.createElement('span');
        spinner.classList.add('form-addons-addToCart--spinner');

        const label = document.createElement('span');
        label.classList.add('btn-label');
        label.textContent = 'Add to cart';

        newAddToCartButton.appendChild(spinner);
        newAddToCartButton.appendChild(label);

        this.originalProductFormEl.appendChild(newAddToCartButton);

        newAddToCartButton.addEventListener('click', () => {
            this.handleAddToCart();
        });
    }

    async handleAddToCart() {
        if (!this.formProduct) return;

        const mainProductId = this.formProduct.querySelector('input.product-variant-id').value;
        const formSelectorLayout = document.querySelector('.form-selector-layout');
        const selectedSizeId = formSelectorLayout.querySelector('.size-selector-wrapper')?.getAttribute('data-selected-size-id');
        const selectedSize = formSelectorLayout.getAttribute('data-selected-size')?.toUpperCase();
        const selectedMaterialId = formSelectorLayout.getAttribute('data-selected-material-id');
        const selectedMaterialName = formSelectorLayout.getAttribute('data-selected-material-name');
        const selectedYear = formSelectorLayout.getAttribute('data-selected-year');
        const selectedMake = formSelectorLayout.getAttribute('data-selected-make');
        const selectedModel = formSelectorLayout.getAttribute('data-selected-model');
        const selectedTrimInput = formSelectorLayout.querySelector('.trim-optional-input');
        const selectedTrimValue = selectedTrimInput ? selectedTrimInput.value : null;
        const isVehicleManualInput = formSelectorLayout.getAttribute('data-vehicle-type-manual-input') === 'true';

        const spinner = document.querySelector('.form-addons-addToCart--spinner');
        const buttonLabel = document.querySelector('.btn-label');

        const customerEmail = document.querySelector('.information-note-container #emailInput')?.value || null;
        const customerPhone = document.querySelector('.information-note-container #phoneInput')?.value || null;
        const customerText = document.querySelector('.information-note-container #textInput')?.value || null;
        const customerTireSize = document.querySelector('.information-note-container #tireSizeInput')?.value || null;
        const customerHeroPlate = document.querySelector('.information-note-container #heroPlateInput')?.value || null;
        const isImageUploadSection = document.querySelector('.image-upload-section') || null;
        const customerUploadImageLater = document.querySelector('.upload-image-later-wrapper #uploadImageLater')?.checked || null;

        const isOtherCarCheckbox = document.querySelector('.other-car-checkbox input')?.checked;
        const otherCarInput = document.querySelector('.other-car-input input');
        const productAddonsBlock = document.querySelector('.product-addons-block') || null;
        const productAddons = productAddonsBlock ? productAddonsBlock.querySelectorAll('ul li input') : null;

        const customerAdditionalNote = {};

        // Validation for vehicle info
        if (this.formSelectorWrapper) {
            if (isOtherCarCheckbox) {
                if (!otherCarInput.value) {
                    alert('Please enter your vehicle year, make, and model.');
                    return;
                } else {
                    customerAdditionalNote['Other vehicle'] = otherCarInput.value;
                }
            } else {
                if (this.vehicleKind !== 'bike') {
                    if (selectedSizeId === null || selectedMaterialId === "" || selectedMaterialId === undefined || selectedSize === null || selectedSize === '' || selectedSize === undefined) {
                        alert('Please select a vehicle size.');
                        return;
                    }
                } else {
                    if (selectedMake === '' || selectedMake === undefined || selectedMake === null) {
                        alert('Please select a bike make.');
                        return;
                    } else {
                        customerAdditionalNote['Make'] = selectedMake;
                    }
                }
            }
        }

        if (isVehicleManualInput) {
            const otherCarInputManual = document.querySelector('.other-car-manual-input-wrapper input');
            if (!otherCarInputManual.value) {
                alert('Please enter your vehicle year, make, and model.');
                return;
            } else {
                customerAdditionalNote['Other vehicle'] = otherCarInputManual.value;
            }
        }

        // Get selected set variant info
        const selectedSetOption = document.querySelector('input[name="set"]:checked');
        let selectedSetName = '';
        let selectedSetId = null;

        if (selectedSetOption) {
            selectedSetName = selectedSetOption.dataset.materialName || '';
            selectedSetId = selectedSetOption.value || null; // variant ID expected here
        }

        const imageURLs = await this.HandleUploadImageField.uploadImage();

        if (isImageUploadSection) {
            const conditionalUploadParent = isImageUploadSection.closest('.conditional-upload');

            const shouldValidate =
                !conditionalUploadParent ||
                (
                    conditionalUploadParent &&
                    window.getComputedStyle(conditionalUploadParent).display !== 'none' &&
                    window.getComputedStyle(conditionalUploadParent).visibility !== 'hidden'
                );

            const noImagesUploaded = !imageURLs || (Array.isArray(imageURLs) && imageURLs.length === 0);

            if (shouldValidate && !customerUploadImageLater && noImagesUploaded) {
                alert('Please upload at least one image.');
                return;
            }
        }

        spinner.style.visibility = 'visible';
        buttonLabel.style.visibility = 'hidden';

        const mediaUrlsDict = {};
        if (imageURLs && imageURLs.length > 0) {
            imageURLs.forEach((imageURL, index) => {
                mediaUrlsDict[`Media-${index + 1}`] = imageURL.url;
            });
        }

        let formData = { items: [] };
        let alongItemsLocalStore = [];
        const extraCoverCheckbox = document.getElementById('extraCoverSteering');
        const extraCoverStrapCheckbox = document.getElementById('extraCoverStrap');
        const extraGarageMatCheckbox = document.getElementById('extraGarageMat');

        const fields = {
            'Year': selectedYear,
            'Make': selectedMake,
            'Model': selectedModel,
            'Size': selectedSize,
            'Email': customerEmail,
            'Phone': customerPhone,
            'Plate': customerHeroPlate,
            'Upload Image Later': customerUploadImageLater ? 'Yes' : null,
            'Material': selectedMaterialName,
            'Trim': selectedTrimValue,
            'Tire size': customerTireSize,
            'Text': customerText,
        };

        for (const [key, value] of Object.entries(fields)) {
            if (value) {
                customerAdditionalNote[key] = value;
            }
        }
        

        // Add main product with properties (including selected set name)
        if (mainProductId) {
            formData.items.push({
            id: mainProductId,
            quantity: 1,
            properties: {
                ...(extraCoverCheckbox ? { "Steering wheel Cover": extraCoverCheckbox.checked ? "Yes" : "No" } : {}),
                ...(extraCoverStrapCheckbox ? { "Car Cover Straps": extraCoverStrapCheckbox.checked ? "Yes" : "No" } : {}),
                ...(extraGarageMatCheckbox ? { "Car Cover Straps": extraGarageMatCheckbox.checked ? "Yes" : "No" } : {}),
                ...customerAdditionalNote,
                ...mediaUrlsDict,
                ...(selectedSetName && { "Selected Set": selectedSetName }),
            }
            });
        }
        
        // Add addons if checked
        if (productAddons) {
            productAddons.forEach(addonItem => {
                if (addonItem.checked) {
                    formData.items.push({
                        id: addonItem.value,
                        quantity: 1
                    });
                }
            });
        }
        
        if (extraCoverCheckbox && extraCoverCheckbox.checked) {
        const steeringVariantId = "45733975195819"; 
        formData.items.push({
            id: steeringVariantId,
            quantity: 1,
            properties: {
            "Added with": "Main Product"
            }
        });
        }
        if (extraGarageMatCheckbox && extraGarageMatCheckbox.checked) {
        const garagematVariantId = "47359178080427"; 
        formData.items.push({
            id: garagematVariantId,
            quantity: 1,
            properties: {
            "Added with": "Main Product"
            }
        });
        }
        if (extraCoverStrapCheckbox && extraCoverStrapCheckbox.checked) {
        const coverstrapVariantId = "46446192951467"; 
        formData.items.push({
            id: coverstrapVariantId,
            quantity: 1,
            properties: {
            "Added with": "Main Product"
            }
        });
        }
        // Add selected size variant as separate item
        if (selectedSizeId) {
            formData.items.push({
                id: selectedSizeId,
                quantity: 1,
                properties: {
                "Added with main product": mainProductId
                }
            });
            alongItemsLocalStore.push(selectedSizeId);
        }

        // Add selected material variant as separate item
        if (selectedMaterialId) {
            formData.items.push({ id: selectedMaterialId, quantity: 1 });
            alongItemsLocalStore.push(selectedMaterialId);
        }

        // Add selected set variant as separate item (variant)
        if (selectedSetId) {
            console.log('Adding selected set variant ID:', selectedSetId);
            formData.items.push({ id: selectedSetId, quantity: 1 });
            alongItemsLocalStore.push(selectedSetId);
        }


        if (!formData.items) {
            formData.items = [];
            return;
        }

        const urlEncodedPayload = new URLSearchParams();
        formData.items.forEach((item, index) => {
            urlEncodedPayload.append(`items[${index}][id]`, item.id);
            urlEncodedPayload.append(`items[${index}][quantity]`, item.quantity);
            if (item.properties) {
                Object.keys(item.properties).forEach(key => {
                    urlEncodedPayload.append(`items[${index}][properties][${key}]`, item.properties[key]);
                });
            }
        });

        fetch(window.Shopify.routes.root + 'cart/add.js', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded',
                'X-Requested-With': 'XMLHttpRequest'
            },
            body: urlEncodedPayload.toString()
        })
            .then(response => response.json())
            .then(data => {
                window.location.href = '/cart';
                spinner.style.visibility = 'hidden';
                buttonLabel.style.visibility = 'visible';
            })
            .catch(error => {
                console.error('Error:', error);
                spinner.style.visibility = 'hidden';
                buttonLabel.style.visibility = 'visible';
            });
    }
}


class SwatchVariantSelector {
    constructor() {
        this.variantInputs = document.querySelectorAll('.variant-swatch-input')

        this.thumbnailList = document.querySelector('[id^="GalleryThumbnails"] .thumbnail-list');

        const productScript = document.getElementById(`ProductJSON-${this.getProductId()}`);
        this.productData = productScript ? JSON.parse(productScript.textContent) : null;

        this.variantIdInput = document.querySelector(`#product-form-${this.productData.section_id} input.product-variant-id`);
        this.formSelectorLayout = document.querySelector('.form-selector-layout');

        this.handleThumbnailClick(this.thumbnailList);
        this.hideDefaultVariantPicker();
        this.variantsSeletorChangeHandle(this.variantInputs)

        this.init();
    }

    handleThumbnailClick(thumbnailList) {
        if (!thumbnailList) return;
        thumbnailList.addEventListener('click', (e) => {
            const target = e.target.closest('li');
            if (!target) return;
            const variantId = target.getAttribute('data-target').split(this.productData.section_id + '-')[1];
            this.updateMedia(variantId);
        });

    }

    updatePrice(variantId) {
        if (!variantId) return;
        const newVariantPrice = this.productData.variants.find(v => v.id.toString() === variantId.toString()).price;
        const priceSpan = document.querySelector('.price-item--regular');
        if (this.formSelectorLayout) {
            this.formSelectorLayout.setAttribute('data-product-price', newVariantPrice);
            this.formSelectorLayout.setAttribute('data-variant-id', variantId);
            const materialPrice = parseFloat(this.formSelectorLayout.getAttribute('data-selected-material-price')) || 0;
            const sizePrice = parseFloat(this.formSelectorLayout.getAttribute('data-size-price')) || 0;
            const totalPrice = ((newVariantPrice + materialPrice + sizePrice) / 100).toFixed(2);
            if (priceSpan) {
                priceSpan.textContent = `$${Number(totalPrice).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })} USD`;
            }
        }

    }


    updateMedia(variantId) {
        if (!variantId) return;
        const galleryThumbnails = document.querySelector('[id^="GalleryThumbnails"]');
        const galleryViewer = document.querySelector('[id^="GalleryViewer"]');
        const desktopView = window.innerWidth >= 750;

        if (galleryViewer && galleryThumbnails) {

            // Update main viewer
            const viewerMediaElement = galleryViewer.querySelector(`[data-media-id="${this.productData.section_id}-${variantId}"]`);
            if (viewerMediaElement) {
                if (desktopView) {
                    // Hide all media elements
                    galleryViewer.querySelectorAll('[data-media-id]').forEach(el => {
                        el.style.display = 'none';
                    });
                    viewerMediaElement.style.display = 'block';
                } else {
                    // Scroll the media element into view
                    viewerMediaElement.scrollIntoView({
                        behavior: 'smooth',
                        block: 'center',
                        inline: 'center'
                    });
                }
            }

            // Update thumbnails
            const thumbnailElement = galleryThumbnails.querySelector(`[data-target="${this.productData.section_id}-${variantId}"]`);
            if (thumbnailElement) {
                // Update aria-current attributes
                galleryThumbnails.querySelectorAll('[data-target]').forEach(el => {
                    el.querySelector('button')?.removeAttribute('aria-current');
                });
                thumbnailElement.querySelector('button')?.setAttribute('aria-current', 'true');

                // Scroll the thumbnail into view
                const scrollContainer = galleryThumbnails.querySelector('.thumbnail-list');
                if (scrollContainer) {
                    const containerRect = scrollContainer.getBoundingClientRect();
                    const thumbnailRect = thumbnailElement.getBoundingClientRect();
                    const scrollLeft = thumbnailRect.left - containerRect.left + scrollContainer.scrollLeft;

                    scrollContainer.scrollTo({
                        left: scrollLeft,
                        behavior: 'smooth'
                    });
                }
            }
        }
    }

    getVariantFeatureMediaID(variantId) {
        if (!variantId) return;
        const variant = this.productData.variants.find(v => v.id.toString() === variantId.toString());
        if (!variant || !variant.featured_media) return;
        this.updateMedia(variant.featured_media.id)
    }


    getProductId() {
        const productInfo = document.querySelector('product-info');
        return productInfo?.dataset?.productId;
    }

    init() {
        if (!this.productData) {
            console.warn("Product not found")
            return;
        }
        this.updatePrice(this.productData.selected_variant.id)
    }

    hideDefaultVariantPicker() {
        const defaultVariantPicker = document.querySelector("variant-selects")

        if (defaultVariantPicker) {
            defaultVariantPicker.remove();
        }
    }

    variantsSeletorChangeHandle(variantsSelector) {
        if (!variantsSelector) return;
        variantsSelector.forEach(variantInput => {
            variantInput.addEventListener('change', () => {
                if (variantInput.checked) {
                    const selectedVariantId = variantInput.value;
                    this.updateURL(selectedVariantId)
                    this.handleUpdateProductInfo(selectedVariantId)
                }
            });
        });
    }

    handleUpdateProductInfo(variantId) {
        this.variantIdInput.value = variantId;

        this.getVariantFeatureMediaID(variantId)
        this.updatePrice(variantId)
    }

    updateURL(variantId) {
        if (variantId) {
            const currentUrl = window.location.href.split('?')[0];
            const newUrl = `${currentUrl}?variant=${variantId}`;
            window.history.replaceState({}, '', newUrl);
        }
    }
}

// Initialize the uploader when the DOM is ready
document.addEventListener('DOMContentLoaded', () => {
    new FormAddonSelector();
    // new SwatchVariantSelector();
    new AddToCartCustom();
    new HandleUploadImageField().uplodaImageEventListeners();
});



document.addEventListener('DOMContentLoaded', function () {
    const embroideryOptions = document.querySelectorAll('input[name="embroidery"]');
    const conditionalUpload = document.querySelector('.conditional-upload');
    const textInputContainer = document.querySelector('.text-input-container');

    function clearInputs(container) {
        if (!container) return;
        // Clear all input, textarea, select inside container
        const inputs = container.querySelectorAll('input, textarea, select');
        inputs.forEach(input => {
            if (input.type === 'checkbox' || input.type === 'radio') {
                input.checked = false;
            } else {
                input.value = '';
            }
        });
    }

    function toggleEmbroideryFields() {
        const isEmbroidery1 = document.querySelector('input[id="embroidery-1"]:checked');
        const isEmbroidery2 = document.querySelector('input[id="embroidery-2"]:checked');

        if (conditionalUpload) {
            conditionalUpload.style.display = isEmbroidery1 ? 'block' : 'none';
            if (isEmbroidery2) {
                clearInputs(conditionalUpload);
            }
        }

        if (textInputContainer) {
            textInputContainer.style.display = isEmbroidery2 ? 'block' : 'none';
            if (isEmbroidery1) {
                clearInputs(textInputContainer);
            }
        }
    }

    // Initialize on page load
    toggleEmbroideryFields();

    // Attach change event
    embroideryOptions.forEach(option => {
        option.addEventListener('change', toggleEmbroideryFields);
    });
});

